<template>
  <v-menu>
    <template #activator="{on}">
      <v-layout
        align-center
        row
        justify-end
        v-on="on"
      >
        <v-btn
          :class="classes"
          :icon="$vuetify.breakpoint.smAndDown"
          flat
        >
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <span class="text-none">{{ text }}</span>
            <v-icon class="pl-2 pr-1">
              {{ icon }}
            </v-icon>
          </template>
          <v-icon v-else>
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-layout>
    </template>
    <slot name="content" />
  </v-menu>
</template>

<script>
export default {
  props: {
    text: String,
    icon: {
      type: String,
      default: () => 'arrow_drop_down',
    },
  },
  computed: {
    classes() {
      return {
        'pl-2 pr-0 mx-0': this.$vuetify.breakpoint.mdAndUp,
        'px-0 mx-0': this.$vuetify.breakpoint.smAndDown,
      };
    },
  },
};
</script>
